// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/intro_logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/cycle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/cycle1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/fun1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/fun2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/fun3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/fun4.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/fun5.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images/fun6.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images/fun7.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fun-intro {
    padding: 0.52083rem 0;
    /* margin-bottom: 100px; */
}
.fun-intro-img {
    /* background: url('../../assets/images/img_gongneng.png'); */
    width: 7.875rem;
    height: 4.69271rem;
    background-size: contain;
    margin: 0 auto;
}
.fun-intro-wrap {
    width: 7.875rem;
    height: 4.69271rem;
    margin: 0 auto;
    position: relative;
}
.fun-intro-center {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    width: 1.5625rem;
    height: 1.5625rem;
    left: 50%;
    top: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
}
.fun-intro-cycle {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    width: 3.41667rem;
    height: 3.32813rem;
    left: 50%;
    top: 50%;
    position: absolute;
    margin-left: -1.70833rem;
    margin-top: -1.66146rem;
    background-size: contain;
}
.fun-intro-second-cycle {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: contain;
    width: 4.11458rem;
    height: 4.11458rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.fun-intro-item {
    display: flex;
    position: absolute;
    align-items: center;
    text-align: left;
    /* visibility: visible; */
    /* animation-delay: 0.1s; */
    /* animation: fadeInUp 1s ease; */
}
.fun1-item {
    left: 3.59375rem;
    top: -0.15625rem;
}
.fun2-item {
    left: 5.3125rem;
    top: 0.78125rem
}
.fun3-item {
    left: 5.57292rem;
    top: 2.34375rem
}
.fun4-item {
    left: 4.53125rem;
    top: 3.75rem
}
.fun5-item {
    left: 0.15625rem;
    top: 3.80208rem;
    text-align: right;
}

.fun6-item {
    left: -0.9375rem;
    top: 2.34375rem;
    text-align: right;
}
.fun7-item {
    left: -0.41667rem;
    top: 0.625rem;
    text-align: right;
}
.fun-intro-item-icon {
    width: 0.78125rem;
    height: 0.78125rem;
    background-repeat: no-repeat;
    background-size: contain;
}
.fun-intro-item-icon.fun1 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.fun-intro-item-icon.fun2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.fun-intro-item-icon.fun3 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.fun-intro-item-icon.fun4 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.fun-intro-item-icon.fun5 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.fun-intro-item-icon.fun6 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.fun-intro-item-icon.fun7 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.fun-intro-item-content {
    width: 2.16667rem;
    margin-left: 0.15625rem;
}
.fun5-item .fun-intro-item-content, .fun6-item .fun-intro-item-content, .fun7-item .fun-intro-item-content {
    margin-right: 0.15625rem;
}
.fun-intro-item-content-title {
    color: #474D58;
    margin-bottom: 0.10417rem;
    font-size: 0.125rem;
    font-weight: 600;
}

.fun-intro-item-content-detail {
    color: #6F7783;
    font-size: 0.08333rem;
}


@media screen and (max-width: 850px) { 
    .fun1-item .fun-intro-item-content {
        width: 2.86458rem;
    }
}

@media screen and (max-width: 750px) { 
    .fun-intro-item {
        align-items:flex-start;
    }
    .fun-intro-item-content-title {
         font-size: 0.1875rem;
    }
    .fun-intro-item-content-detail {
        transform-origin:left top;
        transform: scale(0.9);
    }
    .fun5-item .fun-intro-item-content-detail,
    .fun6-item .fun-intro-item-content-detail,
    .fun7-item .fun-intro-item-content-detail{
        transform-origin:right top;
    }
}
@media screen and (max-width: 700px) {
    .fun1-item .fun-intro-item-content, .fun4-item .fun-intro-item-content {
        width: 3.64583rem;
    }
    .fun-intro-item-content-detail {
        transform: scale(0.8);
    }
}

@media screen and (max-width: 500px) { 
    .fun-intro-item-content-detail {
        transform: scale(0.75);
    }
}
@media screen and (max-width: 700px) { 
    .fun-intro-item-content-detail {
        transform: scale(0.5);
        font-size: 0.25rem;
    }
    .fun-intro-item-content{
        width:3.64583rem;
    }
    .fun1-item .fun-intro-item-content, .fun4-item .fun-intro-item-content {
        width: 6.25rem;
    } 
    .fun5-item {
        left: -1.19792rem;
    }
    .fun6-item {
        left: -2.34375rem;
    }
    .fun7-item {
        left: -1.92708rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/FunIntro/FunIntro.css"],"names":[],"mappings":"AAAA;IACI,qBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,6DAA6D;IAC7D,eAAa;IACb,kBAAa;IACb,wBAAwB;IACxB,cAAc;AAClB;AACA;IACI,eAAa;IACb,kBAAa;IACb,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,mDAAqD;IACrD,wBAAwB;IACxB,gBAAY;IACZ,iBAAa;IACb,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,mDAAgD;IAChD,4BAA4B;IAC5B,iBAAY;IACZ,kBAAa;IACb,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,wBAAmB;IACnB,uBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,mDAAiD;IACjD,wBAAwB;IACxB,iBAAY;IACZ,kBAAa;IACb,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;IAC3B,iCAAiC;AACrC;AACA;IACI,gBAAW;IACX,gBAAU;AACd;AACA;IACI,eAAY;IACZ;AACJ;AACA;IACI,gBAAY;IACZ;AACJ;AACA;IACI,gBAAW;IACX;AACJ;AACA;IACI,gBAAU;IACV,eAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,gBAAY;IACZ,eAAU;IACV,iBAAiB;AACrB;AACA;IACI,iBAAW;IACX,aAAU;IACV,iBAAiB;AACrB;AACA;IACI,iBAAY;IACZ,kBAAa;IACb,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;IACI,yDAAqD;AACzD;AACA;IACI,yDAAqD;AACzD;AACA;IACI,yDAAqD;AACzD;AACA;IACI,yDAAqD;AACzD;AACA;IACI,yDAAqD;AACzD;AACA;IACI,yDAAqD;AACzD;AACA;IACI,yDAAqD;AACzD;AACA;IACI,iBAAY;IACZ,uBAAiB;AACrB;AACA;IACI,wBAAkB;AACtB;AACA;IACI,cAAc;IACd,yBAAmB;IACnB,mBAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAe;AACnB;;;AAGA;IACI;QACI,iBAAY;IAChB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;SACK,oBAAe;IACpB;IACA;QACI,yBAAyB;QACzB,qBAAqB;IACzB;IACA;;;QAGI,0BAA0B;IAC9B;AACJ;AACA;IACI;QACI,iBAAY;IAChB;IACA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;AACA;IACI;QACI,qBAAqB;QACrB,kBAAe;IACnB;IACA;QACI,gBAAW;IACf;IACA;QACI,cAAa;IACjB;IACA;QACI,iBAAY;IAChB;IACA;QACI,iBAAY;IAChB;IACA;QACI,iBAAY;IAChB;AACJ","sourcesContent":[".fun-intro {\n    padding: 100px 0px;\n    /* margin-bottom: 100px; */\n}\n.fun-intro-img {\n    /* background: url('../../assets/images/img_gongneng.png'); */\n    width: 1512px;\n    height: 901px;\n    background-size: contain;\n    margin: 0 auto;\n}\n.fun-intro-wrap {\n    width: 1512px;\n    height: 901px;\n    margin: 0 auto;\n    position: relative;\n}\n.fun-intro-center {\n    background: url('../../assets/images/intro_logo.png');\n    background-size: contain;\n    width: 300px;\n    height: 300px;\n    left: 50%;\n    top: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n}\n.fun-intro-cycle {\n    background: url('../../assets/images/cycle.svg');\n    background-repeat: no-repeat;\n    width: 656px;\n    height: 639px;\n    left: 50%;\n    top: 50%;\n    position: absolute;\n    margin-left: -328px;\n    margin-top: -319px;\n    background-size: contain;\n}\n.fun-intro-second-cycle {\n    background: url('../../assets/images/cycle1.png');\n    background-size: contain;\n    width: 790px;\n    height: 790px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.fun-intro-item {\n    display: flex;\n    position: absolute;\n    align-items: center;\n    text-align: left;\n    /* visibility: visible; */\n    /* animation-delay: 0.1s; */\n    /* animation: fadeInUp 1s ease; */\n}\n.fun1-item {\n    left: 690px;\n    top: -30px;\n}\n.fun2-item {\n    left: 1020px;\n    top: 150px\n}\n.fun3-item {\n    left: 1070px;\n    top: 450px\n}\n.fun4-item {\n    left: 870px;\n    top: 720px\n}\n.fun5-item {\n    left: 30px;\n    top: 730px;\n    text-align: right;\n}\n\n.fun6-item {\n    left: -180px;\n    top: 450px;\n    text-align: right;\n}\n.fun7-item {\n    left: -80px;\n    top: 120px;\n    text-align: right;\n}\n.fun-intro-item-icon {\n    width: 150px;\n    height: 150px;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n.fun-intro-item-icon.fun1 {\n    background-image: url('../../assets/images/fun1.svg');\n}\n.fun-intro-item-icon.fun2 {\n    background-image: url('../../assets/images/fun2.svg');\n}\n.fun-intro-item-icon.fun3 {\n    background-image: url('../../assets/images/fun3.svg');\n}\n.fun-intro-item-icon.fun4 {\n    background-image: url('../../assets/images/fun4.svg');\n}\n.fun-intro-item-icon.fun5 {\n    background-image: url('../../assets/images/fun5.svg');\n}\n.fun-intro-item-icon.fun6 {\n    background-image: url('../../assets/images/fun6.svg');\n}\n.fun-intro-item-icon.fun7 {\n    background-image: url('../../assets/images/fun7.svg');\n}\n.fun-intro-item-content {\n    width: 416px;\n    margin-left: 30px;\n}\n.fun5-item .fun-intro-item-content, .fun6-item .fun-intro-item-content, .fun7-item .fun-intro-item-content {\n    margin-right: 30px;\n}\n.fun-intro-item-content-title {\n    color: #474D58;\n    margin-bottom: 20px;\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.fun-intro-item-content-detail {\n    color: #6F7783;\n    font-size: 16px;\n}\n\n\n@media screen and (max-width: 850px) { \n    .fun1-item .fun-intro-item-content {\n        width: 550px;\n    }\n}\n\n@media screen and (max-width: 750px) { \n    .fun-intro-item {\n        align-items:flex-start;\n    }\n    .fun-intro-item-content-title {\n         font-size: 36px;\n    }\n    .fun-intro-item-content-detail {\n        transform-origin:left top;\n        transform: scale(0.9);\n    }\n    .fun5-item .fun-intro-item-content-detail,\n    .fun6-item .fun-intro-item-content-detail,\n    .fun7-item .fun-intro-item-content-detail{\n        transform-origin:right top;\n    }\n}\n@media screen and (max-width: 700px) {\n    .fun1-item .fun-intro-item-content, .fun4-item .fun-intro-item-content {\n        width: 700px;\n    }\n    .fun-intro-item-content-detail {\n        transform: scale(0.8);\n    }\n}\n\n@media screen and (max-width: 500px) { \n    .fun-intro-item-content-detail {\n        transform: scale(0.75);\n    }\n}\n@media screen and (max-width: 700px) { \n    .fun-intro-item-content-detail {\n        transform: scale(0.5);\n        font-size: 48px;\n    }\n    .fun-intro-item-content{\n        width:700px;\n    }\n    .fun1-item .fun-intro-item-content, .fun4-item .fun-intro-item-content {\n        width: 1200px;\n    } \n    .fun5-item {\n        left: -230px;\n    }\n    .fun6-item {\n        left: -450px;\n    }\n    .fun7-item {\n        left: -370px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
